module.exports = __webpack_public_path__ + "img/paycash.83d0974.png";